window.showFlashModal = function() {
  const modal = document.getElementById('flash-modal');
  if (modal) {
    modal.style.display = 'block';
  }
};

window.showExpressModal = function() {
  const modal = document.getElementById('express-modal');
  if (modal) {
    modal.style.display = 'block';
  }
};

window.closeModal = function(modalId) {
  const modal = document.getElementById(modalId);
  if (modal) {
    modal.style.display = 'none';
  }
};

/**
 * Servicios de Entrega en el Mismo Día
 * Script para gestionar los horarios de corte, días disponibles y mensajes para los servicios de entrega
 */

document.addEventListener('DOMContentLoaded', function() {
  // Inicializar la sección de servicios de entrega
  initSamedayDeliverySection();
  
  // Si hay un elemento delivery-message, inicializar con formato de banners
  const deliveryMessage = document.getElementById('delivery-message');
  if (deliveryMessage && deliveryMessage.parentElement.classList.contains('delivery-message')) {
    initBannerFormat();
  }

  updateCollectionDeliveryTooltipsCountdown();
  setInterval(updateCollectionDeliveryTooltipsCountdown, 1000);
});

/**
 * Inicializa el formato de banners (formato original)
 */
function initBannerFormat() {
  const deliveryElement = document.getElementById('delivery-message');
  if (!deliveryElement) return;
  
  const now = new Date();
  
  // Priorizar configuración global si está disponible
  if (window.deliverySchedulingManager && window.deliverySchedulingManager.config && window.deliverySchedulingManager.config.enabled) {
    console.log('Usando configuración global del schema');
    
    // Obtener configuración de servicios desde el manager global
    const service2Config = window.deliverySchedulingManager.getServiceConfig('2');
    const service1Config = window.deliverySchedulingManager.getServiceConfig('1');
    
    let flashCutoff = null;
    let expressCutoff = null;
    
    // Verificar si los servicios están habilitados ANTES de obtener horarios
    // Verificar tanto boolean true como string "true" para compatibilidad
    const service2Enabled = service2Config && (service2Config.enabled === true || service2Config.enabled === 'true' || service2Config.enabled === 1);
    const service1Enabled = service1Config && (service1Config.enabled === true || service1Config.enabled === 'true' || service1Config.enabled === 1);
    
    console.log('Estado de servicios:', {
      service2: { config: service2Config, enabled: service2Enabled },
      service1: { config: service1Config, enabled: service1Enabled }
    });
    
    if (service2Enabled) {
      console.log('Servicio 2 (Flash) está habilitado en el schema');
      // Verificar también que el día actual esté habilitado
      const isAvailableToday = window.deliverySchedulingManager.isServiceAvailable('2', now);
      if (isAvailableToday) {
        const cutoff = window.deliverySchedulingManager.getCutoffTime('2', now);
        if (cutoff) {
          flashCutoff = new Date();
          flashCutoff.setHours(cutoff.hour, cutoff.minute, 0, 0);
        } else {
          // Si no hay cutoff configurado, usar valores por defecto
          flashCutoff = new Date();
          flashCutoff.setHours(14, 0, 0, 0);
        }
      } else {
        console.log('Servicio 2 (Flash) no está disponible HOY (día deshabilitado o feriado) - mostrará próximo día disponible');
        // Aún así crear un cutoff para mostrar el banner con mensaje del próximo día
        flashCutoff = new Date();
        flashCutoff.setHours(0, 0, 0, 0); // Usar hora 0 para que siempre muestre el mensaje del próximo día
      }
    } else {
      console.log('Servicio 2 (Flash) está DESHABILITADO en el schema - NO se mostrará');
    }
    
    if (service1Enabled) {
      console.log('Servicio 1 (Express) está habilitado en el schema');
      // Verificar también que el día actual esté habilitado
      const isAvailableToday = window.deliverySchedulingManager.isServiceAvailable('1', now);
      if (isAvailableToday) {
        const cutoff = window.deliverySchedulingManager.getCutoffTime('1', now);
        if (cutoff) {
          expressCutoff = new Date();
          expressCutoff.setHours(cutoff.hour, cutoff.minute, 0, 0);
        } else {
          // Si no hay cutoff configurado, usar valores por defecto
          expressCutoff = new Date();
          expressCutoff.setHours(17, 30, 0, 0);
        }
      } else {
        console.log('Servicio 1 (Express) no está disponible HOY (día deshabilitado o feriado) - mostrará próximo día disponible');
        // Aún así crear un cutoff para mostrar el banner con mensaje del próximo día
        expressCutoff = new Date();
        expressCutoff.setHours(0, 0, 0, 0); // Usar hora 0 para que siempre muestre el mensaje del próximo día
      }
    } else {
      console.log('Servicio 1 (Express) está DESHABILITADO en el schema - NO se mostrará');
    }
    
    // Mostrar servicios que están habilitados (aunque no estén disponibles hoy)
    // Solo llamar a las funciones si los cutoffs están definidos
    if (service2Enabled && service1Enabled && flashCutoff && expressCutoff) {
      updateBothServicesBanners(flashCutoff, expressCutoff);
    } else if (service2Enabled && flashCutoff) {
      updateFlashBanner(flashCutoff);
    } else if (service1Enabled && expressCutoff) {
      updateExpressBanner(expressCutoff);
    } else {
      // Ningún servicio está habilitado o no hay cutoffs válidos, limpiar el contenedor
      console.log('Ningún servicio está habilitado o no hay cutoffs válidos');
      deliveryElement.innerHTML = '';
    }
    
    return;
  }
  
  // Fallback: usar configuración de atributos data-* (valores hardcodeados o de sección)
  // Si el elemento HTML no existe, significa que Liquid lo ocultó porque está deshabilitado
  console.log('Usando configuración de atributos data-*');
  const service2 = document.querySelector('[data-service-id="2"]');
  const service1 = document.querySelector('[data-service-id="1"]');
  
  // Si no hay elementos, significa que están deshabilitados en Liquid
  if (!service2 && !service1) {
    console.log('Ningún servicio encontrado en el DOM (probablemente deshabilitados)');
    deliveryElement.innerHTML = '';
    return;
  }
  
  // Obtener configuraciones desde atributos
  let flashCutoff = null;
  let expressCutoff = null;
  
  if (service2) {
    const hour = parseInt(service2.getAttribute('data-cutoff-hour'), 10);
    const minute = parseInt(service2.getAttribute('data-cutoff-minute'), 10);
    if (!isNaN(hour) && !isNaN(minute)) {
      flashCutoff = new Date();
      flashCutoff.setHours(hour, minute, 0, 0);
    }
  }
  
  if (service1) {
    const hour = parseInt(service1.getAttribute('data-cutoff-hour'), 10);
    const minute = parseInt(service1.getAttribute('data-cutoff-minute'), 10);
    if (!isNaN(hour) && !isNaN(minute)) {
      expressCutoff = new Date();
      expressCutoff.setHours(hour, minute, 0, 0);
    }
  }
  
  // Si ambos servicios están disponibles, mostrar ambos
  if (flashCutoff && expressCutoff) {
    updateBothServicesBanners(flashCutoff, expressCutoff);
  } else if (flashCutoff) {
    updateFlashBanner(flashCutoff);
  } else if (expressCutoff) {
    updateExpressBanner(expressCutoff);
  } else {
    // Ningún servicio disponible
    deliveryElement.innerHTML = '';
  }
}

/**
 * Actualiza ambos banners (Flash y Express)
 */
async function updateBothServicesBanners(flashCutoff, expressCutoff) {
  const now = new Date();
  const deliveryElement = document.getElementById('delivery-message');
  if (!deliveryElement) return;
  
  // Verificar si es antes de las 10:00 AM (declarar al inicio para que esté disponible en todo el scope)
  const currentTime = now.getHours() * 60 + now.getMinutes();
  const isBefore10AM = currentTime < 10 * 60;
  
  // Verificar feriados y disponibilidad usando configuración global si está disponible
  let isHoliday = false;
  let flashAvailable = true;
  let expressAvailable = true;
  let flashIsHolidayToday = false;
  let expressIsHolidayToday = false;
  
  // Verificar si los servicios están habilitados globalmente
  const service2Config = window.deliverySchedulingManager?.getServiceConfig('2');
  const service1Config = window.deliverySchedulingManager?.getServiceConfig('1');
  const service2Enabled = service2Config && (service2Config.enabled === true || service2Config.enabled === 'true' || service2Config.enabled === 1);
  const service1Enabled = service1Config && (service1Config.enabled === true || service1Config.enabled === 'true' || service1Config.enabled === 1);
  
  if (window.deliverySchedulingManager && window.deliverySchedulingManager.config && window.deliverySchedulingManager.config.enabled) {
    isHoliday = await checkIfHoliday(null);
    flashAvailable = service2Enabled && window.deliverySchedulingManager.isServiceAvailable('2', now);
    expressAvailable = service1Enabled && window.deliverySchedulingManager.isServiceAvailable('1', now);
    
    // Verificar si hoy es feriado para cada servicio
    flashIsHolidayToday = window.deliverySchedulingManager.isHoliday(now) || 
                          window.deliverySchedulingManager.isServiceSpecificHoliday(now, '2');
    expressIsHolidayToday = window.deliverySchedulingManager.isHoliday(now) || 
                            window.deliverySchedulingManager.isServiceSpecificHoliday(now, '1');
  } else {
    isHoliday = await checkIfHoliday(null);
  }
  
  // Si un servicio está deshabilitado globalmente, no está disponible
  if (!service2Enabled) {
    flashAvailable = false;
  }
  if (!service1Enabled) {
    expressAvailable = false;
  }
  
  // Verificar que los cutoffs existan antes de usarlos
  if (!flashCutoff || !expressCutoff) {
    console.error('Error: flashCutoff o expressCutoff es null/undefined');
    return;
  }
  
  // Calcular tiempos para Flash
  let flashTimeDiff = flashCutoff.getTime() - now.getTime();
  flashTimeDiff = Math.max(flashTimeDiff, 0);
  const flashHours = Math.floor(flashTimeDiff / (1000 * 60 * 60));
  const flashMinutes = Math.floor((flashTimeDiff % (1000 * 60 * 60)) / (1000 * 60));
  const flashSeconds = Math.floor((flashTimeDiff % (1000 * 60)) / 1000);
  
  // Calcular tiempos para Express
  let expressTimeDiff = expressCutoff.getTime() - now.getTime();
  expressTimeDiff = Math.max(expressTimeDiff, 0);
  const expressHours = Math.floor(expressTimeDiff / (1000 * 60 * 60));
  const expressMinutes = Math.floor((expressTimeDiff % (1000 * 60 * 60)) / (1000 * 60));
  const expressSeconds = Math.floor((expressTimeDiff % (1000 * 60)) / 1000);
  
  // Solo mostrar si al menos un servicio está habilitado (aunque no esté disponible hoy)
  if (!service2Enabled && !service1Enabled) {
    deliveryElement.innerHTML = '';
    return;
  }
  
  // Verificar si mañana es feriado o no está disponible (para ambos servicios)
  const tomorrow = new Date(now);
  tomorrow.setDate(now.getDate() + 1);
  tomorrow.setHours(0, 0, 0, 0);
  
  // Construir HTML completo para todos los servicios habilitados
  let html = '';
  
  if (service2Enabled) {
    // Determinar el texto del banner según si ya pasó el cutoff
    const flashBannerText = flashTimeDiff > 0 ? 'LLEGA EN 2H CON ENVÍO FLASH' : 'ENVÍO FLASH';
    
    html += `
      <div class="flash-banner">
        ${flashBannerText}
        <span class="info-icon" onclick="showFlashModal()">
          <svg fill="#ffffff" width="800px" height="800px" viewBox="-2 -2 24 24" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin" class="jam jam-info">
            <path d='M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-10a1 1 0 0 1 1 1v5a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1zm0-1a1 1 0 1 1 0-2 1 1 0 0 1 0 2z'/>
          </svg>
        </span>
      </div>`;
    
    const tomorrowIsHolidayFlash = window.deliverySchedulingManager && 
                              window.deliverySchedulingManager.config && 
                              window.deliverySchedulingManager.config.enabled &&
                              (window.deliverySchedulingManager.isHoliday(tomorrow) || 
                               window.deliverySchedulingManager.isServiceSpecificHoliday(tomorrow, '2'));
    const tomorrowIsAvailableFlash = window.deliverySchedulingManager && 
                                 window.deliverySchedulingManager.config && 
                                 window.deliverySchedulingManager.config.enabled &&
                                 window.deliverySchedulingManager.isServiceAvailable('2', tomorrow);
    
    // Mostrar countdown solo si hay tiempo restante, el servicio está disponible hoy Y es después de las 10:00 AM
    if (flashTimeDiff > 0 && flashAvailable && !flashIsHolidayToday && !isBefore10AM) {
      html += `<div class="countdown-title">Pide antes de <span class="remaining-time" id="flash-countdown">${flashHours}h ${flashMinutes}m ${flashSeconds}s</span></div>`;
    } else if (isBefore10AM && flashAvailable && !flashIsHolidayToday) {
      // Si es antes de las 10:00 AM, mostrar mensaje sin countdown con nombre del día
      const dayNames = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
      const todayName = dayNames[now.getDay()];
      html += `<div class="countdown-title">LLEGA HOY ${todayName.toUpperCase()} ANTES DE LAS 12:30 PM</div>`;
    } else {
      // Si no hay countdown (ya pasó el cutoff o es feriado/no disponible), mostrar mensaje del próximo día disponible
      let flashMessage = '';
      if (window.deliverySchedulingManager && window.deliverySchedulingManager.config && window.deliverySchedulingManager.config.enabled) {
        // Si hoy es feriado o no está disponible, buscar el próximo día disponible
        if (flashIsHolidayToday || !flashAvailable) {
          flashMessage = window.deliverySchedulingManager.getNextAvailableDayMessage('2', now);
        } 
        // Si mañana es feriado o no está disponible, buscar el próximo día disponible desde mañana
        else if (tomorrowIsHolidayFlash || !tomorrowIsAvailableFlash) {
          console.log('Flash: Mañana es feriado o no está disponible, buscando desde mañana');
          flashMessage = window.deliverySchedulingManager.getNextAvailableDayMessage('2', tomorrow);
        } 
        // Si está disponible pero pasó el cutoff, usar el mensaje de hoy
        else {
          flashMessage = window.deliverySchedulingManager.getDayMessage('2', now);
        }
      }
      if (flashMessage) {
        html += `<div class="countdown-title">${flashMessage}</div>`;
      }
    }
    
    html += `<div class="province-info">Sólo a 6km de Santiago Centro</div>`;
  }
  
  if (service1Enabled) {
    if (flashAvailable) {
      html += `<div style="margin-top: 5px;">`;
    }
    
    // Determinar el texto del banner según si ya pasó el cutoff
    const dayNames = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
    const todayName = dayNames[now.getDay()];
    const expressBannerText = expressTimeDiff > 0 ? `RECIBE HOY ${todayName.toUpperCase()} CON ENVÍO EXPRESS` : 'ENVÍO EXPRESS';
    
    html += `<div class="express-banner">
      ${expressBannerText}
      <span class="info-icon" onclick="showExpressModal()">
        <svg fill="#ffffff" width="800px" height="800px" viewBox="-2 -2 24 24" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin" class="jam jam-info">
          <path d='M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-10a1 1 0 0 1 1 1v5a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1zm0-1a1 1 0 1 1 0-2 1 1 0 0 1 0 2z'/>
        </svg>
      </span>
    </div>`;
    
    const tomorrowIsHolidayExpress = window.deliverySchedulingManager && 
                              window.deliverySchedulingManager.config && 
                              window.deliverySchedulingManager.config.enabled &&
                              (window.deliverySchedulingManager.isHoliday(tomorrow) || 
                               window.deliverySchedulingManager.isServiceSpecificHoliday(tomorrow, '1'));
    const tomorrowIsAvailableExpress = window.deliverySchedulingManager && 
                                 window.deliverySchedulingManager.config && 
                                 window.deliverySchedulingManager.config.enabled &&
                                 window.deliverySchedulingManager.isServiceAvailable('1', tomorrow);
    
    // Mostrar countdown solo si hay tiempo restante, el servicio está disponible hoy Y es después de las 10:00 AM
    if (expressTimeDiff > 0 && expressAvailable && !expressIsHolidayToday && !isBefore10AM) {
      html += `<div class="countdown-title">Pide antes de <span class="remaining-time" id="express-countdown">${expressHours}h ${expressMinutes}m ${expressSeconds}s</span></div>`;
    } else if (isBefore10AM && expressAvailable && !expressIsHolidayToday) {
      // Si es antes de las 10:00 AM, mostrar mensaje sin countdown con nombre del día
      const dayNames = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
      const todayName = dayNames[now.getDay()];
      html += `<div class="countdown-title">LLEGA HOY ${todayName.toUpperCase()} DURANTE EL DIA</div>`;
    } else {
      // Si no hay countdown (ya pasó el cutoff o es feriado/no disponible), mostrar mensaje del próximo día disponible
      let expressMessage = '';
      if (window.deliverySchedulingManager && window.deliverySchedulingManager.config && window.deliverySchedulingManager.config.enabled) {
        // Si hoy es feriado o no está disponible, buscar el próximo día disponible
        if (expressIsHolidayToday || !expressAvailable) {
          expressMessage = window.deliverySchedulingManager.getNextAvailableDayMessage('1', now);
        } 
        // Si mañana es feriado o no está disponible, buscar el próximo día disponible desde mañana
        else if (tomorrowIsHolidayExpress || !tomorrowIsAvailableExpress) {
          console.log('Express: Mañana es feriado o no está disponible, buscando desde mañana');
          expressMessage = window.deliverySchedulingManager.getNextAvailableDayMessage('1', tomorrow);
        } 
        // Si está disponible pero pasó el cutoff, usar el mensaje de hoy
        else {
          expressMessage = window.deliverySchedulingManager.getDayMessage('1', now);
        }
      }
      if (expressMessage) {
        html += `<div class="countdown-title">${expressMessage}</div>`;
      }
    }
    
    html += `<div class="province-info">Sólo en la provincia de Santiago Urbano</div>`;
    if (flashAvailable) {
      html += `</div>`;
    }
  }
  
  deliveryElement.innerHTML = html;
  
  // Iniciar countdowns solo si están disponibles Y es después de las 10:00 AM
  if (flashAvailable && flashTimeDiff > 0 && !isHoliday && !isBefore10AM) {
    const flashCountdownEl = document.getElementById('flash-countdown');
    if (flashCountdownEl) {
      startCountdown(flashCutoff, flashCountdownEl, '');
    }
  }
  
  if (expressAvailable && expressTimeDiff > 0 && !isHoliday && !isBefore10AM) {
    const expressCountdownEl = document.getElementById('express-countdown');
    if (expressCountdownEl) {
      startCountdown(expressCutoff, expressCountdownEl, '');
    }
  }
  
  // Obtener horarios de corte para modales desde configuración global si está disponible
  let flashHour = 14, flashMinute = 0;
  let expressHour = 17, expressMinute = 30;
  
  if (window.deliverySchedulingManager && window.deliverySchedulingManager.config && window.deliverySchedulingManager.config.enabled) {
    const flashCutoffConfig = window.deliverySchedulingManager.getCutoffTime('2', now);
    const expressCutoffConfig = window.deliverySchedulingManager.getCutoffTime('1', now);
    if (flashCutoffConfig) {
      flashHour = flashCutoffConfig.hour;
      flashMinute = flashCutoffConfig.minute;
    }
    if (expressCutoffConfig) {
      expressHour = expressCutoffConfig.hour;
      expressMinute = expressCutoffConfig.minute;
    }
  } else {
    flashHour = flashCutoff.getHours();
    flashMinute = flashCutoff.getMinutes();
    expressHour = expressCutoff.getHours();
    expressMinute = expressCutoff.getMinutes();
  }
  
  // Crear modales
  if (flashAvailable) {
    createServiceModal('flash-modal', 'ENVIO FLASH', '2', flashHour, flashMinute);
  }
  if (expressAvailable) {
    createServiceModal('express-modal', 'ENVIO EXPRESS', '1', expressHour, expressMinute);
  }
}

/**
 * Actualiza solo el banner Flash
 */
async function updateFlashBanner(cutoff) {
  const now = new Date();
  const deliveryElement = document.getElementById('delivery-message');
  if (!deliveryElement) return;
  
  // Verificar que el cutoff exista
  if (!cutoff) {
    console.error('Error: cutoff es null/undefined en updateFlashBanner');
    return;
  }
  
  // Verificar disponibilidad usando configuración global si está disponible
  let isAvailable = true;
  let isHolidayToday = false;
  const service2Config = window.deliverySchedulingManager?.getServiceConfig('2');
  const service2Enabled = service2Config && (service2Config.enabled === true || service2Config.enabled === 'true' || service2Config.enabled === 1);
  
  if (window.deliverySchedulingManager && window.deliverySchedulingManager.config && window.deliverySchedulingManager.config.enabled) {
    isAvailable = service2Enabled && window.deliverySchedulingManager.isServiceAvailable('2', now);
    isHolidayToday = window.deliverySchedulingManager.isHoliday(now) || 
                     window.deliverySchedulingManager.isServiceSpecificHoliday(now, '2');
  }
  
  // Si el servicio está deshabilitado globalmente, no mostrar nada
  if (!service2Enabled) {
    deliveryElement.innerHTML = '';
    return;
  }
  
  const isHoliday = await checkIfHoliday('2');
  let timeDiff = cutoff.getTime() - now.getTime();
  timeDiff = Math.max(timeDiff, 0);
  const hours = Math.floor(timeDiff / (1000 * 60 * 60));
  const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);
  
  // Determinar el texto del banner según si ya pasó el cutoff
  const flashBannerText = timeDiff > 0 ? 'LLEGA EN 2H CON ENVÍO FLASH' : 'ENVÍO FLASH';
  
  let html = `
    <div class="flash-banner">
      ${flashBannerText}
      <span class="info-icon" onclick="showFlashModal()">
        <svg fill="#ffffff" width="800px" height="800px" viewBox="-2 -2 24 24" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin" class="jam jam-info">
          <path d='M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-10a1 1 0 0 1 1 1v5a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1zm0-1a1 1 0 1 1 0-2 1 1 0 0 1 0 2z'/>
        </svg>
      </span>
    </div>`;
  
  // Verificar si es antes de las 10:00 AM
  const currentTime = now.getHours() * 60 + now.getMinutes();
  const isBefore10AM = currentTime < 10 * 60;
  
  // Mostrar countdown solo si hay tiempo restante, el servicio está disponible hoy Y es después de las 10:00 AM
  if (timeDiff > 0 && isAvailable && !isHolidayToday && !isBefore10AM) {
    html += `<div class="countdown-title">Pide antes de <span class="remaining-time" id="flash-countdown">${hours}h ${minutes}m ${seconds}s</span></div>`;
  } else if (isBefore10AM && isAvailable && !isHolidayToday) {
    // Si es antes de las 10:00 AM, mostrar mensaje sin countdown con nombre del día
    const dayNames = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
    const todayName = dayNames[now.getDay()];
    html += `<div class="countdown-title">LLEGA HOY ${todayName.toUpperCase()} ANTES DE LAS 12:30 PM</div>`;
  } else {
    // Si no hay countdown (ya pasó el cutoff o es feriado), mostrar mensaje del próximo día disponible
    let flashMessage = '';
    if (window.deliverySchedulingManager && window.deliverySchedulingManager.config && window.deliverySchedulingManager.config.enabled) {
      // Si hoy es feriado o no está disponible, buscar el próximo día disponible
      if (isHolidayToday || !isAvailable) {
        flashMessage = window.deliverySchedulingManager.getNextAvailableDayMessage('2', now);
      } else {
        // Si está disponible pero pasó el cutoff, usar el mensaje de hoy
        flashMessage = window.deliverySchedulingManager.getDayMessage('2', now);
      }
    }
    if (flashMessage) {
      html += `<div class="countdown-title">${flashMessage}</div>`;
    }
  }
  
  html += `<div class="province-info">Sólo a 6km de Santiago Centro</div>`;
  
  deliveryElement.innerHTML = html;
  
  if (timeDiff > 0 && !isHoliday && !isBefore10AM) {
    const countdownEl = document.getElementById('flash-countdown');
    if (countdownEl) {
      startCountdown(cutoff, countdownEl, '');
    }
  }
  
  // Obtener horario de corte para modal desde configuración global si está disponible
  let flashHour = 14, flashMinute = 0;
  if (window.deliverySchedulingManager && window.deliverySchedulingManager.config && window.deliverySchedulingManager.config.enabled) {
    const flashCutoffConfig = window.deliverySchedulingManager.getCutoffTime('2', now);
    if (flashCutoffConfig) {
      flashHour = flashCutoffConfig.hour;
      flashMinute = flashCutoffConfig.minute;
    }
  } else {
    flashHour = cutoff.getHours();
    flashMinute = cutoff.getMinutes();
  }
  
  createServiceModal('flash-modal', 'ENVIO FLASH', '2', flashHour, flashMinute);
}

/**
 * Actualiza solo el banner Express
 */
async function updateExpressBanner(cutoff) {
  const now = new Date();
  const deliveryElement = document.getElementById('delivery-message');
  if (!deliveryElement) return;
  
  // Verificar que el cutoff exista
  if (!cutoff) {
    console.error('Error: cutoff es null/undefined en updateExpressBanner');
    return;
  }
  
  // Verificar disponibilidad usando configuración global si está disponible
  let isAvailable = true;
  let isHolidayToday = false;
  const service1Config = window.deliverySchedulingManager?.getServiceConfig('1');
  const service1Enabled = service1Config && (service1Config.enabled === true || service1Config.enabled === 'true' || service1Config.enabled === 1);
  
  if (window.deliverySchedulingManager && window.deliverySchedulingManager.config && window.deliverySchedulingManager.config.enabled) {
    isAvailable = service1Enabled && window.deliverySchedulingManager.isServiceAvailable('1', now);
    isHolidayToday = window.deliverySchedulingManager.isHoliday(now) || 
                     window.deliverySchedulingManager.isServiceSpecificHoliday(now, '1');
  }
  
  // Si el servicio está deshabilitado globalmente, no mostrar nada
  if (!service1Enabled) {
    deliveryElement.innerHTML = '';
    return;
  }
  
  const isHoliday = await checkIfHoliday('1');
  let timeDiff = cutoff.getTime() - now.getTime();
  timeDiff = Math.max(timeDiff, 0);
  const hours = Math.floor(timeDiff / (1000 * 60 * 60));
  const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);
  
  // Determinar el texto del banner según si ya pasó el cutoff
  const dayNames = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
  const todayName = dayNames[now.getDay()];
  const expressBannerText = timeDiff > 0 ? `RECIBE HOY ${todayName.toUpperCase()} CON ENVÍO EXPRESS` : 'ENVÍO EXPRESS';
  
  let html = `
    <div class="express-banner">
      ${expressBannerText}
      <span class="info-icon" onclick="showExpressModal()">
        <svg fill="#ffffff" width="800px" height="800px" viewBox="-2 -2 24 24" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin" class="jam jam-info">
          <path d='M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-10a1 1 0 0 1 1 1v5a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1zm0-1a1 1 0 1 1 0-2 1 1 0 0 1 0 2z'/>
        </svg>
      </span>
    </div>`;
  
  // Verificar si es antes de las 10:00 AM
  const currentTime = now.getHours() * 60 + now.getMinutes();
  const isBefore10AM = currentTime < 10 * 60;
  
  // Mostrar countdown solo si hay tiempo restante, el servicio está disponible hoy Y es después de las 10:00 AM
  if (timeDiff > 0 && isAvailable && !isHolidayToday && !isBefore10AM) {
    html += `<div class="countdown-title">Pide antes de <span class="remaining-time" id="express-countdown">${hours}h ${minutes}m ${seconds}s</span></div>`;
  } else if (isBefore10AM && isAvailable && !isHolidayToday) {
    // Si es antes de las 10:00 AM, mostrar mensaje sin countdown con nombre del día
    const dayNames = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
    const todayName = dayNames[now.getDay()];
    html += `<div class="countdown-title">LLEGA HOY ${todayName.toUpperCase()} DURANTE EL DIA</div>`;
  } else {
    // Si no hay countdown (ya pasó el cutoff o es feriado), mostrar mensaje del próximo día disponible
    let expressMessage = '';
    if (window.deliverySchedulingManager && window.deliverySchedulingManager.config && window.deliverySchedulingManager.config.enabled) {
      // Si hoy es feriado o no está disponible, buscar el próximo día disponible
      if (isHolidayToday || !isAvailable) {
        expressMessage = window.deliverySchedulingManager.getNextAvailableDayMessage('1', now);
      } else {
        // Si está disponible pero pasó el cutoff, usar el mensaje de hoy
        expressMessage = window.deliverySchedulingManager.getDayMessage('1', now);
      }
    }
    if (expressMessage) {
      html += `<div class="countdown-title">${expressMessage}</div>`;
    }
  }
  
  html += `<div class="province-info">Sólo en la provincia de Santiago Urbano</div>`;
  
  deliveryElement.innerHTML = html;
  
  if (timeDiff > 0 && !isHoliday && !isBefore10AM) {
    const countdownEl = document.getElementById('express-countdown');
    if (countdownEl) {
      startCountdown(cutoff, countdownEl, '');
    }
  }
  
  // Obtener horario de corte para modal desde configuración global si está disponible
  let expressHour = 17, expressMinute = 30;
  if (window.deliverySchedulingManager && window.deliverySchedulingManager.config && window.deliverySchedulingManager.config.enabled) {
    const expressCutoffConfig = window.deliverySchedulingManager.getCutoffTime('1', now);
    if (expressCutoffConfig) {
      expressHour = expressCutoffConfig.hour;
      expressMinute = expressCutoffConfig.minute;
    }
  } else {
    expressHour = cutoff.getHours();
    expressMinute = cutoff.getMinutes();
  }
  
  createServiceModal('express-modal', 'ENVIO EXPRESS', '1', expressHour, expressMinute);
}

/**
 * Inicializa la sección de servicios de entrega
 */
function initSamedayDeliverySection() {
  const sections = document.querySelectorAll('[data-sameday-section]');
  
  if (!sections.length) return;
  
  sections.forEach(section => {
    console.log("Inicializando sección de servicios de entrega");
    const considerHolidays = section.getAttribute('data-consider-holidays') === 'true';
    const showCountdown = section.getAttribute('data-show-countdown') === 'true';
    const showTooltip = section.getAttribute('data-show-tooltip') === 'true';
    
    // Inicializar servicios
    const services = section.querySelectorAll('.sameday-service');
    console.log(`Servicios encontrados: ${services.length}`);
    services.forEach(service => {
      initService(service, considerHolidays, showCountdown, section);
    });
    
    // Inicializar modal si está habilitado
    if (showTooltip) {
      initModal(section);
    }
  });
}

/**
 * Inicializa un servicio de entrega individual
 * @param {HTMLElement} serviceElement - El elemento HTML del servicio
 * @param {boolean} considerHolidays - Si se deben considerar los días feriados
 * @param {boolean} showCountdown - Si se debe mostrar la cuenta regresiva
 * @param {HTMLElement} section - La sección completa para obtener textos personalizados
 */
function initService(serviceElement, considerHolidays, showCountdown, section) {
  const serviceId = serviceElement.getAttribute('data-service-id');
  
  // Intentar usar configuraciones globales si están disponibles
  let cutoffHour, cutoffMinute, availableDays;
  let useGlobalConfig = false;
  
  if (window.deliverySchedulingManager && window.deliverySchedulingManager.config && window.deliverySchedulingManager.config.enabled) {
    const serviceConfig = window.deliverySchedulingManager.getServiceConfig(serviceId);
    
    if (serviceConfig && serviceConfig.enabled) {
      useGlobalConfig = true;
      const now = new Date();
      const cutoff = window.deliverySchedulingManager.getCutoffTime(serviceId, now);
      
      if (cutoff) {
        cutoffHour = cutoff.hour;
        cutoffMinute = cutoff.minute;
        
        // Construir días disponibles desde la configuración global
        const dayNames = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
        availableDays = {};
        dayNames.forEach((dayName, index) => {
          const dayIndex = index === 0 ? 0 : index; // Domingo es 0
          availableDays[dayIndex] = serviceConfig.days[dayName] && serviceConfig.days[dayName].enabled;
        });
        
        console.log(`Usando configuración global para servicio ${serviceId} - Hora de corte: ${cutoffHour}:${cutoffMinute}`);
      }
    }
  }
  
  // Si no se pudo usar la configuración global, usar la configuración de la sección
  if (!useGlobalConfig) {
    cutoffHour = parseInt(serviceElement.getAttribute('data-cutoff-hour'), 10);
    cutoffMinute = parseInt(serviceElement.getAttribute('data-cutoff-minute'), 10);
    
    console.log(`Usando configuración de sección para servicio ${serviceId} - Hora de corte: ${cutoffHour}:${cutoffMinute}`);
    
    // Días disponibles desde atributos de datos
    availableDays = {
    1: serviceElement.getAttribute('data-monday') === 'true',
    2: serviceElement.getAttribute('data-tuesday') === 'true',
    3: serviceElement.getAttribute('data-wednesday') === 'true',
    4: serviceElement.getAttribute('data-thursday') === 'true',
    5: serviceElement.getAttribute('data-friday') === 'true',
    6: serviceElement.getAttribute('data-saturday') === 'true',
    0: serviceElement.getAttribute('data-sunday') === 'true'
  };
  }
  
  // Elementos de mensaje y cuenta regresiva
  const messageElement = document.getElementById(`service${serviceId}-message`);
  const countdownElement = document.getElementById(`service${serviceId}-countdown`);
  
  if (!messageElement) {
    console.error(`Elemento de mensaje para servicio ${serviceId} no encontrado`);
    return;
  }
  
  // Verificar si es un día feriado (si está habilitado)
  if (considerHolidays) {
    checkIfHoliday(serviceId).then(isHoliday => {
      updateDeliveryMessage(serviceElement, messageElement, countdownElement, cutoffHour, cutoffMinute, availableDays, isHoliday, showCountdown, section, serviceId);
    });
  } else {
    updateDeliveryMessage(serviceElement, messageElement, countdownElement, cutoffHour, cutoffMinute, availableDays, false, showCountdown, section, serviceId);
  }
}

/**
 * Verifica si hoy es un día feriado
 * @param {string|number} serviceId - ID del servicio (opcional, para verificar feriados específicos)
 * @returns {Promise<boolean>} - Promesa que resuelve a true si es feriado, false si no lo es
 */
function checkIfHoliday(serviceId) {
  return new Promise((resolve) => {
    const today = new Date();
    
    // Primero verificar si hay un gestor de programación global
    if (window.deliverySchedulingManager && window.deliverySchedulingManager.config && window.deliverySchedulingManager.config.enabled) {
      // Verificar feriados generales
      let isHoliday = window.deliverySchedulingManager.isHoliday(today);
      
      // Si hay un serviceId, también verificar feriados específicos del servicio
      if (serviceId && !isHoliday) {
        isHoliday = window.deliverySchedulingManager.isServiceSpecificHoliday(today, serviceId);
      }
      
      // Si está habilitado usar API de feriados y no encontramos feriados personalizados, verificar API
      if (!isHoliday && window.deliverySchedulingManager.config.useApiHolidays) {
        // Continuar con la verificación de API
        checkHolidayFromAPI(today).then(apiHoliday => {
          resolve(apiHoliday || isHoliday);
        });
        return;
      }
      
      resolve(isHoliday);
      return;
    }
    
    // Si no hay configuración global, usar solo la API
    checkHolidayFromAPI(today).then(resolve);
  });
}

/**
 * Verifica si una fecha es feriado usando la API
 * @param {Date} date - La fecha a verificar
 * @returns {Promise<boolean>} - Promesa que resuelve a true si es feriado
 */
function checkHolidayFromAPI(date) {
  return new Promise((resolve) => {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    
    // Intentar API de Boostr primero
    fetch(`https://api.boostr.cl/holidays.json`)
      .then(response => response.json())
      .then(data => {
        const dateString = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
        const isHoliday = data.data && data.data.some(holiday => holiday.date === dateString);
        console.log(`Verificación de feriado (API Boostr): ${isHoliday ? 'Es feriado' : 'No es feriado'}`);
        resolve(isHoliday);
      })
      .catch(error => {
        console.warn('Error al verificar feriado con API Boostr, intentando API alternativa:', error);
        // Fallback a API alternativa
        fetch(`https://apis.digital.gob.cl/fl/feriados/${year}/${month}/${day}`)
          .then(response => response.json())
          .then(data => {
            const isHoliday = data && data.nombre ? true : false;
            console.log(`Verificación de feriado (API alternativa): ${isHoliday ? 'Es feriado' : 'No es feriado'}`);
            resolve(isHoliday);
      })
      .catch(error => {
        console.error('Error al verificar si es día feriado:', error);
        resolve(false);
          });
      });
  });
}

/**
 * Actualiza el mensaje de entrega y la cuenta regresiva
 * @param {HTMLElement} serviceElement - El elemento HTML del servicio
 * @param {HTMLElement} messageElement - El elemento para mostrar el mensaje
 * @param {HTMLElement} countdownElement - El elemento para mostrar la cuenta regresiva
 * @param {number} cutoffHour - La hora de corte (0-23)
 * @param {number} cutoffMinute - El minuto de corte (0-59)
 * @param {Object} availableDays - Objeto con los días disponibles
 * @param {boolean} isHoliday - Si hoy es un día feriado
 * @param {boolean} showCountdown - Si se debe mostrar la cuenta regresiva
 * @param {HTMLElement} section - La sección completa para obtener textos personalizados
 * @param {string|number} serviceId - ID del servicio (opcional)
 */
function updateDeliveryMessage(serviceElement, messageElement, countdownElement, cutoffHour, cutoffMinute, availableDays, isHoliday, showCountdown, section, serviceId) {
  const now = new Date();
  const dayOfWeek = now.getDay(); // 0 (domingo) a 6 (sábado)
  
  console.log(`Actualizando mensaje - Día de la semana: ${dayOfWeek}, Es feriado: ${isHoliday}`);
  
  // Si estamos usando configuración global, obtener el horario de corte dinámicamente
  if (window.deliverySchedulingManager && window.deliverySchedulingManager.config && window.deliverySchedulingManager.config.enabled && serviceId) {
    const cutoff = window.deliverySchedulingManager.getCutoffTime(serviceId, now);
    if (cutoff) {
      cutoffHour = cutoff.hour;
      cutoffMinute = cutoff.minute;
      
      // Verificar disponibilidad usando el gestor global
      const isAvailable = window.deliverySchedulingManager.isServiceAvailable(serviceId, now);
      if (!isAvailable) {
        isHoliday = true; // Marcar como no disponible
      }
    }
  }
  
  // Construir fecha de corte para hoy
  const cutoffTime = new Date();
  cutoffTime.setHours(cutoffHour, cutoffMinute, 0, 0);
  
  // Obtener textos personalizados de los atributos de datos
  const texts = {
    today: section.getAttribute('data-today-text') || 'Si compras ahora tu pedido llegará hoy',
    tomorrow: section.getAttribute('data-tomorrow-text') || 'Si compras ahora tu pedido llegará mañana',
    monday: section.getAttribute('data-monday-text') || 'Si compras ahora tu pedido llegará el lunes',
    countdown: section.getAttribute('data-countdown-text') || 'Compra dentro de'
  };
  
  console.log('Textos personalizados:', texts);
  
  // Verificar si el servicio está disponible hoy
  const isAvailableToday = !isHoliday && availableDays[dayOfWeek];
  
  // Si hoy no está disponible o es un día feriado
  if (!isAvailableToday) {
    // Encontrar el próximo día disponible
    let nextAvailableDay = findNextAvailableDay(dayOfWeek, availableDays, serviceId);
    
    if (nextAvailableDay === 1) { // Si el próximo día disponible es lunes
      messageElement.innerHTML = texts.monday;
    } else if (nextAvailableDay === (dayOfWeek + 1) % 7) { // Si es mañana
      messageElement.innerHTML = texts.tomorrow;
    } else {
      const dayNames = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
      messageElement.innerHTML = `Si compras ahora tu pedido llegará el ${dayNames[nextAvailableDay]}`;
    }
    
    if (countdownElement) {
      countdownElement.style.display = 'none';
    }
    return;
  }
  
  // Determinar qué servicio es para usar el banner correcto
  const serviceName = serviceId === '2' || serviceId === 2 ? 'flash' : 
                       serviceId === '1' || serviceId === 1 ? 'express' : 'express';
  const isFlash = serviceName === 'flash';
  const bannerClass = isFlash ? 'flash-banner' : 'express-banner';
  
  // Textos de los banners según el servicio
  const dayNames = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
  const todayName = dayNames[now.getDay()];
  const bannerText = isFlash ? 'LLEGA EN 2H CON ENVÍO FLASH' : `RECIBE HOY ${todayName.toUpperCase()} CON ENVÍO EXPRESS`;
  const provinceText = isFlash ? 'Sólo a 6km de Santiago Centro' : 'Sólo en la provincia de Santiago Urbano';
  const modalId = isFlash ? 'flash-modal' : 'express-modal';
  const modalTitle = isFlash ? 'ENVIO FLASH' : 'ENVIO EXPRESS';
  const showModalFunction = isFlash ? 'showFlashModal()' : 'showExpressModal()';
  
  // Usar el gestor global si está disponible para obtener el mensaje
  let deliveryInfo = null;
  if (window.deliverySchedulingManager && window.deliverySchedulingManager.config && window.deliverySchedulingManager.config.enabled && serviceId) {
    deliveryInfo = window.deliverySchedulingManager.getDeliveryMessage(serviceId, now);
  }
  
  // Verificar si es antes de las 10:00 AM
  const currentTime = now.getHours() * 60 + now.getMinutes();
  const isBefore10AM = currentTime < 10 * 60;
  
  // Si está disponible hoy y es antes de la hora de corte
  if (now < cutoffTime && isAvailableToday) {
    // Si tenemos información del gestor, usarla
    if (deliveryInfo) {
      let html = `
        <div class="${bannerClass}">
          ${deliveryInfo.message}
          <span class="info-icon" onclick="${showModalFunction}">
            <svg fill="#ffffff" width="800px" height="800px" viewBox="-2 -2 24 24" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin" class="jam jam-info">
              <path d='M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-10a1 1 0 0 1 1 1v5a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1zm0-1a1 1 0 1 1 0-2 1 1 0 0 1 0 2z'/>
            </svg>
          </span>
        </div>`;
      
      // Mostrar mensaje de "llega hoy" si está configurado
      if (deliveryInfo.showTomorrow && deliveryInfo.tomorrowMessage) {
        html += `<div class="countdown-title">${deliveryInfo.tomorrowMessage}</div>`;
      }
      
      // Mostrar cuenta regresiva SOLO si está habilitada, es después de las 10:00 AM y hay targetTime
      if (!isBefore10AM && deliveryInfo.showCountdown && deliveryInfo.targetTime && countdownElement) {
        const targetDate = new Date(deliveryInfo.targetTime);
        html += `<div class="countdown-title">Pide antes de <span class="remaining-time" id="countdown-${serviceId}"></span></div>`;
        messageElement.innerHTML = html;
        startCountdown(targetDate, document.getElementById(`countdown-${serviceId}`), '');
      } else {
        messageElement.innerHTML = html;
      }
    } else {
      // Lógica original si no hay gestor
      let html = `
        <div class="${bannerClass}">
          ${bannerText}
          <span class="info-icon" onclick="${showModalFunction}">
            <svg fill="#ffffff" width="800px" height="800px" viewBox="-2 -2 24 24" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin" class="jam jam-info">
              <path d='M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-10a1 1 0 0 1 1 1v5a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1zm0-1a1 1 0 1 1 0-2 1 1 0 0 1 0 2z'/>
            </svg>
          </span>
        </div>`;
      
      // De 0:00 a 10:00 - mostrar "LLEGA HOY [DÍA] ANTES DE LAS 12:30PM" sin countdown
      const currentTime = now.getHours() * 60 + now.getMinutes();
      if (currentTime < 10 * 60) {
        const dayNames = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
        const todayName = dayNames[now.getDay()];
        html += `<div class="countdown-title">${isFlash ? `LLEGA HOY ${todayName.toUpperCase()} ANTES DE LAS 12:30 PM` : `LLEGA HOY ${todayName.toUpperCase()} DURANTE EL DIA`}</div>`;
        messageElement.innerHTML = html;
      } else {
        // Mostrar cuenta regresiva si está habilitada (desde las 10:00 AM)
        if (showCountdown && countdownElement) {
          html += `<div class="countdown-title">Pide antes de <span class="remaining-time" id="countdown-${serviceId}"></span></div>`;
          messageElement.innerHTML = html;
          startCountdown(cutoffTime, document.getElementById(`countdown-${serviceId}`), '');
        } else {
          messageElement.innerHTML = html;
        }
      }
    }
    
    // Agregar información de provincia
    if (countdownElement && countdownElement.nextElementSibling) {
      countdownElement.nextElementSibling.innerHTML = `<div class="province-info">${provinceText}</div>`;
    } else {
      const provinceDiv = document.createElement('div');
      provinceDiv.className = 'province-info';
      provinceDiv.textContent = provinceText;
      messageElement.parentNode.insertBefore(provinceDiv, messageElement.nextSibling);
    }
    
    // Crear modal si no existe
    createServiceModal(modalId, modalTitle, serviceId, cutoffHour, cutoffMinute);
  } 
  // Si es viernes después de la hora de corte
  else if (dayOfWeek === 5) {
    messageElement.innerHTML = `
      <div class="${bannerClass}">
        ${bannerText}
        <span class="info-icon" onclick="${showModalFunction}">
          <svg fill="#ffffff" width="800px" height="800px" viewBox="-2 -2 24 24" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin" class="jam jam-info">
            <path d='M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-10a1 1 0 0 1 1 1v5a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1zm0-1a1 1 0 1 1 0-2 1 1 0 0 1 0 2z'/>
          </svg>
        </span>
      </div>
      <div class="countdown-title">${texts.monday}</div>
      <div class="province-info">${provinceText}</div>`;
    if (countdownElement) {
      countdownElement.style.display = 'none';
    }
    createServiceModal(modalId, modalTitle, serviceId, cutoffHour, cutoffMinute);
  } 
  // Si es después de la hora de corte en cualquier otro día de la semana
  else {
    messageElement.innerHTML = `
      <div class="${bannerClass}">
        ${bannerText}
        <span class="info-icon" onclick="${showModalFunction}">
          <svg fill="#ffffff" width="800px" height="800px" viewBox="-2 -2 24 24" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin" class="jam jam-info">
            <path d='M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-10a1 1 0 0 1 1 1v5a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1zm0-1a1 1 0 1 1 0-2 1 1 0 0 1 0 2z'/>
          </svg>
        </span>
      </div>
      <div class="countdown-title">${texts.tomorrow}</div>
      <div class="province-info">${provinceText}</div>`;
    if (countdownElement) {
      countdownElement.style.display = 'none';
    }
    createServiceModal(modalId, modalTitle, serviceId, cutoffHour, cutoffMinute);
  }
}

/**
 * Crea un modal para el servicio si no existe
 */
function createServiceModal(modalId, modalTitle, serviceId, cutoffHour, cutoffMinute) {
  if (document.getElementById(modalId)) {
    return; // El modal ya existe
  }
  
  // Determinar horarios según el servicio
  let cutoffText = '';
  const serviceElement = document.querySelector(`[data-service-id="${serviceId}"]`);
  const sectionModalScheduleText = serviceElement ? serviceElement.getAttribute('data-modal-schedule-text') : '';
  if (sectionModalScheduleText && sectionModalScheduleText.trim() !== '') {
    // Priorizar siempre el texto personalizado expuesto en el HTML
    cutoffText = sectionModalScheduleText.trim();
  } else if (window.deliverySchedulingManager && window.deliverySchedulingManager.config && window.deliverySchedulingManager.config.enabled && serviceId) {
    // Usar el gestor global para obtener los horarios
    cutoffText = window.deliverySchedulingManager.getCutoffScheduleText(serviceId);
  } else {
    // Fallback a valores por defecto
    if (serviceId === '2' || serviceId === 2) {
      // Flash: Lun-Vie 14:00, Sáb 12:00
      cutoffText = 'Lunes a Viernes 18:00 / Sábado 14:00 y Domingo 14:00';
    } else {
      // Express: Lun-Vie 17:30, Sáb 14:00
      cutoffText = `Lunes a Viernes hasta las ${cutoffHour}:${String(cutoffMinute).padStart(2, '0')} / Sábado 14:00 y domingo 14:00`;
    }
  }
  
  const modal = document.createElement('div');
  modal.id = modalId;
  modal.className = 'modal';
  modal.innerHTML = `
    <div class="modal-content">
      <span class="close" onclick="closeModal('${modalId}')">&times;</span>
      <div class="modal-header">
        <h3>${modalTitle}</h3>
        <p><strong>Horario de corte:</strong></p>
        <p>${cutoffText}</p>
      </div>
      <div class="modal-body">
        <p>Para conocer más sobre nuestras políticas de envío puedes leer toda la info en el siguiente link:</p>
        <a href="#" class="more-info-link">Más Información</a>
      </div>
    </div>
  `;
  document.body.appendChild(modal);
}

/**
 * Encuentra el próximo día disponible
 * @param {number} currentDay - El día actual (0-6)
 * @param {Object} availableDays - Objeto con los días disponibles
 * @param {string|number} serviceId - ID del servicio (opcional, para usar configuración global)
 * @returns {number} - El próximo día disponible (0-6)
 */
function findNextAvailableDay(currentDay, availableDays, serviceId) {
  // Si hay configuración global y serviceId, usar el gestor global
  if (window.deliverySchedulingManager && window.deliverySchedulingManager.config && window.deliverySchedulingManager.config.enabled && serviceId) {
    const now = new Date();
    for (let i = 1; i <= 7; i++) {
      const checkDate = new Date(now);
      checkDate.setDate(now.getDate() + i);
      checkDate.setHours(0, 0, 0, 0);
      
      if (window.deliverySchedulingManager.isServiceAvailable(serviceId, checkDate)) {
        return checkDate.getDay();
      }
    }
    // Si no se encuentra ningún día disponible, retornar lunes (1)
    return 1;
  }
  
  // Lógica original para configuración de sección
  let nextDay = (currentDay + 1) % 7;
  const startDay = nextDay;
  
  // Buscar el próximo día disponible
  while (!availableDays[nextDay]) {
    nextDay = (nextDay + 1) % 7;
    
    // Si hemos dado la vuelta completa y no hay días disponibles, usar el día siguiente
    if (nextDay === startDay) {
      return startDay;
    }
  }
  
  return nextDay;
}

/**
 * Inicia la cuenta regresiva hasta la hora de corte
 * @param {Date} cutoffTime - La hora de corte
 * @param {HTMLElement} countdownElement - El elemento para mostrar la cuenta regresiva
 * @param {string} countdownText - El texto para la cuenta regresiva (opcional, si está vacío usa formato corto)
 */
function startCountdown(cutoffTime, countdownElement, countdownText) {
  if (!countdownElement) return;
  
  function updateCountdown() {
    const now = new Date();
    let timeDifference = cutoffTime.getTime() - now.getTime();
    
    // Si ya pasó la hora de corte, detener la cuenta regresiva
    if (timeDifference <= 0) {
      if (window.countdownIntervals && window.countdownIntervals[countdownElement.id]) {
        clearInterval(window.countdownIntervals[countdownElement.id]);
        delete window.countdownIntervals[countdownElement.id];
      }
      countdownElement.style.display = 'none';
      // Recargar la página para actualizar los mensajes
      location.reload();
      return;
    }
    
    // Calcular horas, minutos y segundos restantes
    const hoursLeft = Math.floor(timeDifference / (1000 * 60 * 60));
    const minutesLeft = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
    const secondsLeft = Math.floor((timeDifference % (1000 * 60)) / 1000);
    
    // Formatear la cuenta regresiva - formato corto para banners
    let countdownFormatted = '';
    if (countdownText && countdownText.trim() !== '') {
      countdownFormatted = `${countdownText} `;
    }
    
    // Formato: 4h 26m 49s
    countdownFormatted += `${hoursLeft}h ${minutesLeft}m ${secondsLeft}s`;
    
    countdownElement.textContent = countdownFormatted;
    countdownElement.style.display = 'inline';
  }
  
  // Inicializar objeto de intervalos si no existe
  if (!window.countdownIntervals) {
    window.countdownIntervals = {};
  }
  
  // Actualizar inmediatamente y luego cada segundo
  updateCountdown();
  window.countdownIntervals[countdownElement.id] = setInterval(updateCountdown, 1000);
}

function updateCollectionDeliveryTooltipsCountdown() {
  const now = new Date();
  const tooltips = document.querySelectorAll('.collection-delivery-tooltip');

  tooltips.forEach((tooltip) => {
    const serviceId = tooltip.getAttribute('data-service-id');
    const content = tooltip.querySelector('.collection-delivery-tooltip-content');

    if (!content) return;

    const isFlash = serviceId === '2';

let cutoffHour = isFlash ? 17 : 15;
let cutoffMinute = isFlash ? 0 : 0;
let cutoffText = isFlash
  ? ''
  : '';

    if (window.deliverySchedulingManager?.config?.enabled) {
      const cutoff = window.deliverySchedulingManager.getCutoffTime(serviceId, now);

      if (cutoff) {
        cutoffHour = cutoff.hour;
        cutoffMinute = cutoff.minute;
      }

      if (window.deliverySchedulingManager.getCutoffScheduleText) {
        cutoffText = 'Horario de corte: ' + window.deliverySchedulingManager.getCutoffScheduleText(serviceId);
      }
    }

    const cutoffDate = new Date();
    cutoffDate.setHours(cutoffHour, cutoffMinute, 0, 0);

    const diff = cutoffDate.getTime() - now.getTime();

    if (diff <= 0) {
      content.innerHTML = isFlash
        ? `Envío Flash disponible para el próximo día hábil según cobertura.<br>${cutoffText}`
        : `Envío Express disponible para el próximo día hábil según cobertura.<br>${cutoffText}`;
      return;
    }

    const h = Math.floor(diff / 3600000);
    const m = Math.floor((diff % 3600000) / 60000);
    const s = Math.floor((diff % 60000) / 1000);

    content.innerHTML = isFlash
      ? `Llega en 2h con Envío Flash.<br>Pide antes de ${h}h ${m}m ${s}s.<br>${cutoffText}`
      : `Recibe hoy con Envío Express.<br>Pide antes de ${h}h ${m}m ${s}s.<br>${cutoffText}`;
  });
}

